const THREE = name => Array(3).fill(name);
const TEN = name => Array(10).fill(name);

export const MysteryTypes = {
	JOYFUL: 'JOYFUL',
	SORROWFUL: 'SORROWFUL',
	GLORIOUS: 'GLORIOUS',
	LUMINOUS: 'LUMINOUS'
};

export default [
	'SIGNUM_CRUCIS',
	'APOSTLES_CREED',
	'PATER_NOSTER',
	...THREE('AVE_MARIA'),
	'GLORIA',
	'MYSTERY_1',
	'PATER_NOSTER',
	...TEN('AVE_MARIA'),
	'GLORIA',
	'ORATIO_FATIMA',
	'MYSTERY_2',
	'PATER_NOSTER',
	...TEN('AVE_MARIA'),
	'GLORIA',
	'ORATIO_FATIMA',
	'MYSTERY_3',
	'PATER_NOSTER',
	...TEN('AVE_MARIA'),
	'GLORIA',
	'ORATIO_FATIMA',
	'MYSTERY_4',
	'PATER_NOSTER',
	...TEN('AVE_MARIA'),
	'GLORIA',
	'ORATIO_FATIMA',
	'MYSTERY_5',
	'PATER_NOSTER',
	...TEN('AVE_MARIA'),
	'GLORIA',
	'ORATIO_FATIMA',
	'SALVE_REGINA',
	'SIGNUM_CRUCIS'
];
